(ns dre.components.main-nav.db
  (:require
   [dre.i18n.views :refer [tr]]
   [dre.pages.frontpage.events :as frontpage]
   [re-frame.core :as rf]))


(def registry
  [{:id :frontpage
    :label [tr "Home"]
    :on-click #(rf/dispatch [::frontpage/clear-state])}
   {:id :my-searches
    :related-ids [:tags :signals]
    :label [tr "Saved"]}
   {:id :search
    :label [tr "Results"]}
   {:id :shared
    :label [tr "Shared"]}])


(def index (into {} (map (juxt :id identity)) registry))
